/* eslint-disable */
import React, { useState } from 'react';
import './styles/News.css';
import image1 from '../../assets/images/hero-pattern.png'
import image2 from '../../assets/images/image2.jpg'
import image3 from '../../assets/images/image3.png'
import image4 from '../../assets/images/image4.jpg'
import image5 from '../../assets/images/image5.jpg'
import image6 from '../../assets/images/image6.jpg'
const News = () => {
  const [activeTab, setActiveTab] = useState('all');
  

  const newsItems = [
    {
      id: 1,
      type: 'press-release',
      title: 'Launch of National One Health Strategic Plan 2024-2028',
      excerpt: 'The Ministry of Health officially launches the new strategic plan for integrated health approaches.',
      date: '2024-11-15',
      image: image1,
      category: 'Strategic Planning'
    },
    {
      id: 2,
      type: 'event',
      title: 'World One Health Day Commemoration',
      excerpt: 'Join us in celebrating international One Health day with various community engagement activities.',
      date: '2024-11-03',
      image: image2,
      category: 'Awareness'
    },
    {
      id: 3,
      type: 'report',
      title: 'Monthly Anthrax Situation Report Published',
      excerpt: 'Latest updates on anthrax prevention and control measures across South Sudan.',
      date: '2024-10-28',
      image: image3,
      category: 'Surveillance' 
    },
    {
      id: 4,
      type: 'training',
      title: 'Surge Capacity Training for Rapid Response Teams',
      excerpt: 'Intensive training program for emergency response teams across all states.',
      date: '2024-10-15',
      image: image4,
      category: 'Capacity Building'
    },
    {
      id: 5,
      type: 'research',
      title: 'New Research on Zoonotic Disease Patterns',
      excerpt: 'Groundbreaking study reveals new insights into disease transmission between animals and humans.',
      date: '2024-10-08',
      image: image5,
      category: 'Research'
    },
    {
      id: 6,
      type: 'event',
      title: 'World Rabies Day Celebration',
      excerpt: 'Community awareness campaign and vaccination drive for rabies prevention.',
      date: '2024-09-28',
      image: image6,
      category: 'Vaccination'
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'One Health Technical Working Group Meeting',
      date: '2024-11-20',
      time: '10:00 AM',
      location: 'Ministry of Health HQ',
      type: 'Meeting'
    },
    {
      id: 2,
      title: 'Emergency Response Simulation Exercise',
      date: '2024-11-25',
      time: '8:00 AM',
      location: 'Juba Training Center',
      type: 'Training'
    },
    {
      id: 3,
      title: 'Community Health Awareness Campaign',
      date: '2024-12-05',
      time: '9:00 AM',
      location: 'Various Counties',
      type: 'Outreach'
    }
  ];

  const filteredNews = activeTab === 'all' 
    ? newsItems 
    : newsItems.filter(item => item.type === activeTab);

  return (
    <div className="news-page" id='news-page'>
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>News & Events</h1>
            <p className="page-subtitle">
              Stay updated with the latest developments in health security and One Health initiatives
            </p>
          </div>
        </div>
      </section>

      <section className="news-tabs-section">
        <div className="container">
          <div className="tabs-container">
            <button 
              className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              All News
            </button>
            <button 
              className={`tab-btn ${activeTab === 'press-release' ? 'active' : ''}`}
              onClick={() => setActiveTab('press-release')}
            >
              Press Releases
            </button>
            <button 
              className={`tab-btn ${activeTab === 'event' ? 'active' : ''}`}
              onClick={() => setActiveTab('event')}
            >
              Events
            </button>
            <button 
              className={`tab-btn ${activeTab === 'report' ? 'active' : ''}`}
              onClick={() => setActiveTab('report')}
            >
              Reports
            </button>
          </div>
        </div>
      </section>

      <section className="news-grid-section">
        <div className="container">
          <div className="news-grid">
            {filteredNews.map(item => (
              <article key={item.id} className="news-card">
                <div className="news-image">
                  <img src={item.image} alt={item.title} />
                  <div className="news-category">{item.category}</div>
                </div>
                <div className="news-content">
                  <div className="news-meta">
                    <span className="news-date">
                      {new Date(item.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                    <span className="news-type">{item.type}</span>
                  </div>
                  <h3 className="news-title">{item.title}</h3>
                  <p className="news-excerpt">{item.excerpt}</p>
                  <button className="read-more-btn">Read More</button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="events-section">
        <div className="container">
          <div className="section-header">
            <h2>Upcoming Events</h2>
            <p>Mark your calendar for important health security events</p>
          </div>
          <div className="events-timeline">
            {upcomingEvents.map(event => (
              <div key={event.id} className="event-item">
                <div className="event-date">
                  <div className="event-day">
                    {new Date(event.date).getDate()}
                  </div>
                  <div className="event-month">
                    {new Date(event.date).toLocaleDateString('en-US', { month: 'short' })}
                  </div>
                </div>
                <div className="event-details">
                  <h4>{event.title}</h4>
                  <div className="event-meta">
                    <span>📅 {event.date}</span>
                    <span>🕒 {event.time}</span>
                    <span>📍 {event.location}</span>
                  </div>
                  <span className="event-type">{event.type}</span>
                </div>
                <button className="register-btn">Register</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h3>Stay Informed</h3>
              <p>Subscribe to our monthly One Health bulletin and never miss important updates</p>
            </div>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="newsletter-input"
              />
              <button className="subscribe-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;